export default {
  paged: {
    select: 'id,status,created,fromNumber,destinationNumber,deliveryProvider,destinationDisplay',
    searchSelect: ['fromNumber', 'destinationNumber', 'destinationDisplay'],
  },
  item: {
    expand: {
      agent: { select: 'id,name' },
      processInstance: { select: 'id,name' },
    },
  },
  itemDetail: {
    expand: {
      processInstance: { select: 'id,name' },
      agent: { select: 'id,name' },
      channel: { select: 'id,name' },
      chatThread: { select: 'id,number,name' },
    },
  },
};
